module.exports = __webpack_public_path__ + "static/media/layout.57ab4f7c.png";